import { ViolationStatus } from 'src/app/models/api/violations.model';
import { RuleTag } from 'src/app/models/api/governance/violationRule.model';
import { IntegrationStatusFilter } from 'src/app/models/selectOptions/integrationStatusSelectOptions.model';

export const VIOLATIONS_DEFAULT_FILTER_VALUES: Record<string, string[]> = {
  violationStatus: [ViolationStatus.open],
  ruleTag: [RuleTag.generalAvailability],
  integrationStatus: [IntegrationStatusFilter.active],
};
